import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";

export default function LatestDesign() {
  useEffect(() => {
    document.title = "Latest Design";
  }, []);
  const [designs, setDesigns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [wishlist, setWishlist] = useState([]);
  const [wishlistLoading, setWishlistLoading] = useState(false);

  const [cartItems, setCartItems] = useState([]);
  const navigate = useNavigate();
  const getUser = () => {
    try {
      const user = localStorage.getItem("user");
      return user ? JSON.parse(user) : null;
    } catch {
      return null;
    }
  };

  const user = getUser();
  const userId = user?.id;
  const fetchWishlist = async () => {
    if (!userId) return;

    try {
      setWishlistLoading(true);

      const res = await fetch(
        `https://lifetimedesign.in/LtcJsonAPI.asmx/Getwishlist?user_id=${userId}`,
      );

      const result = await res.json();
      setWishlist(result.data || []);
    } catch (err) {
      console.log(err);
    } finally {
      setWishlistLoading(false);
    }
  };

  const [loadingCart, setLoadingCart] = useState(false);

  const fetchCart = async () => {
    if (!userId) return;

    try {
      const res = await fetch(
        `https://lifetimedesign.in/LtcJsonAPI.asmx/Getcartlist?user_id=${userId}`,
      );

      const result = await res.json();

      // console.log("CART DATA:", result.data);

      setCartItems(result.data || []);
    } catch (err) {
      console.log("Cart fetch error:", err);
    }
  };

  const addToCart = async (design) => {
    if (loadingCart) return;

    try {
      setLoadingCart(true);

      const user = JSON.parse(localStorage.getItem("user"));

      if (!user?.id) {
        alert("Please login first");
        return;
      }

      const designId = design.design_id || design.id;

      const existingItem = cartItems.find(
        (item) => Number(item.design_id ?? item.id) === Number(designId),
      );

      // console.log("EXISTING ITEM:", existingItem);

      let url = "";

      if (existingItem) {
        const cartId = existingItem.cart_id;

        // console.log("REMOVE CART ID:", cartId);

        if (!cartId) {
          alert("cart_id missing");
          return;
        }

        url = `https://lifetimedesign.in/LtcJsonAPI.asmx/RemoveCartDesign?cart_id=${cartId}&user_id=${user.id}`;
      } else {
        url = `https://lifetimedesign.in/LtcJsonAPI.asmx/InsertCartlist?user_id=${user.id}&design_id=${designId}`;
      }

      // console.log("API URL:", url);

      const res = await fetch(url, {
        method: "GET",
      });

      const text = await res.text();

      // console.log("API RESPONSE:", text);

      if (!res.ok) {
        throw new Error("Cart operation failed");
      }

      await fetchCart();
      window.dispatchEvent(new Event("cartUpdated"));
    } catch (err) {
      console.error(err);
      alert("Cart operation failed");
    } finally {
      setLoadingCart(false);
    }
  };

  const isInCart = (design) => {
    const id = design.design_id || design.id;

    return cartItems.some(
      (item) => Number(item.design_id ?? item.id) === Number(id),
    );
  };

  useEffect(() => {
    if (userId) {
      fetchCart();
    } else {
      setCartItems([]);
    }
  }, [userId]);
  useEffect(() => {
    if (userId) {
      fetchWishlist();
    } else {
      setWishlist([]);
    }
  }, [userId]);

  const isInWishlist = (design) =>
    wishlist.some(
      (w) =>
        Number(w.design_id ?? w.id) === Number(design.design_id ?? design.id),
    );

  const toggleWishlist = async (design) => {
    if (!userId) {
      alert("Please login first");
      return;
    }

    try {
      setWishlistLoading(true);

      const designId = design.id || design.design_id;

      const exists = isInWishlist(design);

      let url = "";

      if (exists) {
        const item = wishlist.find(
          (i) => Number(i.design_id ?? i.id) === Number(designId),
        );

        url = `https://lifetimedesign.in/LtcJsonAPI.asmx/RemoveWishlistDesign?cart_id=${item.cart_id}&user_id=${userId}`;
      } else {
        url = `https://lifetimedesign.in/LtcJsonAPI.asmx/InsertWishlist?user_id=${userId}&design_id=${designId}`;
      }

      const res = await fetch(url);

      if (!res.ok) {
        throw new Error("Wishlist operation failed");
      }

      await fetchWishlist();

      window.dispatchEvent(new Event("wishlistUpdated"));
    } catch (err) {
      console.error(err);
    } finally {
      setWishlistLoading(false);
    }
  };
  useEffect(() => {
    fetch("https://lifetimedesign.in/LtcJsonAPI.asmx/DesignListLatest")
      .then((res) => res.json())
      .then((data) => {
        // Handle .asmx response format
        const result = data?.d || data;

        if (result.success) {
          setDesigns(result.data || []);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error:", err);
        setLoading(false);
      });
  }, []);

  const handleClick = (item) => {
    navigate(`/product?code=${item.code}&icid=${item.icid}`);
  };
  const url = "/product?code=${item.code}&icid=${item.icid}";

  if (loading)
    return (
      <div className="page-loader">
        <div className="loader-spinner"></div>
        <h2>Loading Your Design...</h2>
        <p>Please wait while we prepare everything for you.</p>
      </div>
    );

  if (!designs.length)
    return (
      <div className="empty-state text-center py-5">
        <div className="empty-icon mb-3">
          <i className="bi bi-search"></i>
        </div>
        <h4 className="mb-2">No designs found</h4>
      </div>
    );
  const breadcrumbItems = [
    {
      label: (
        <>
          <i className="bi bi-house"></i> Home
        </>
      ),
      link: "/",
    },
    {
      label: "Latest Designs",
      link: "/latest-design",
    },
  ];
  return (
    <>
      <Helmet>
        <title>Latest Embroidery Designs | LifeTime Creation</title>

        <meta
          name="description"
          content="Explore the latest embroidery designs from LifeTime Creation. Discover new machine embroidery designs with detailed stitch, size, area, colour and pricing information."
        />

        <meta name="robots" content="index, follow" />

        <link
          rel="canonical"
          href="https://lifetimecreation.in/latest-design"
        />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Latest Embroidery Designs | LifeTime Creation"
        />

        <meta
          property="og:description"
          content="Explore the latest embroidery designs from LifeTime Creation. Discover new machine embroidery designs with detailed stitch, size, area, colour and pricing information."
        />

        <meta property="og:type" content="website" />

        <meta
          property="og:url"
          content="https://lifetimecreation.in/latest-design"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />

        <meta
          name="twitter:title"
          content="Latest Embroidery Designs | LifeTime Creation"
        />

        <meta
          name="twitter:description"
          content="Explore the latest embroidery designs from LifeTime Creation. Discover new machine embroidery designs with detailed stitch, size, area, colour and pricing information."
        />
      </Helmet>
      <div className="header-container1">
        <div className="container-fluid">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              {breadcrumbItems.map((item, i) => (
                <li
                  key={i}
                  className={`breadcrumb-item ${i === breadcrumbItems.length - 1 ? "active" : ""}`}
                >
                  {i === breadcrumbItems.length - 1 ? (
                    item.label
                  ) : (
                    <a href={item.link}>{item.label}</a>
                  )}
                </li>
              ))}
            </ol>
          </nav>
        </div>
        <h2 className="news-title">Latest Designs</h2>
        <div className="design-grid1">
          {designs.map((item) => (
            <div
              className="design-card"
              key={item.id}
              onClick={() =>
                window.open(
                  `/product?code=${encodeURIComponent(item.code)}&icid=${encodeURIComponent(item.icid)}`,
                  "_blank",
                  "noopener,noreferrer",
                )
              }
            >
              <div className="uniq-image-wrapper">
                <img
                  src={`https://lifetimedesign.in/controlpanel/Designs/${item.image_url}`}
                  alt={item.code}
                  className="uniq-design-image"
                  loading="lazy"
                  onError={(e) => {
                    e.target.src = "/images/no-image.png";
                  }}
                />
              </div>

              <div className="card-body">
                <div className="design-specs">
                  <div className="spec-left text-start">
                    <div>
                      <strong>Code:</strong> {item.code}
                    </div>

                    <div>
                      <strong>Stitch:</strong> {item.stiches}
                    </div>
                    <div>
                      <strong>Height:</strong> {item.packageno}
                    </div>
                    <div>
                      <strong>Concept:</strong> {item.concept}
                    </div>
                  </div>
                  <div className="spec-right text-end">
                    <div>
                      <strong>Area:</strong> {item.area}
                    </div>
                    <div>
                      <strong>Colour:</strong> {item.color}
                    </div>
                    <div>
                      <strong>Width:</strong> {item.sequence}
                    </div>
                  </div>
                </div>
                <h5 className="price-tag-row text-center mt-2">
                  {" "}
                  <span className="rupee-symbol">₹</span> {item.price}
                </h5>
                <div className="card-action-row">
                  <div className="action-btns">
                    <button
                      disabled={loadingCart}
                      className={`select-btn ${isInCart(item) ? "in-cart" : ""}`}
                      onClick={(e) => {
                        e.stopPropagation();
                        addToCart(item);
                      }}
                    >
                      {isInCart(item) ? (
                        <>
                          <i className="bi bi-cart-check-fill me-1"></i>
                          SELECTED
                        </>
                      ) : (
                        <>
                          <i className="bi bi-cart me-1"></i>
                          SELECT DESIGN
                        </>
                      )}
                    </button>

                    <button
                      className={`wish-btn ${isInWishlist(item) ? "active" : ""}`}
                      onClick={(e) => {
                        e.stopPropagation();
                        toggleWishlist(item);
                      }}
                      disabled={wishlistLoading}
                    >
                      <i
                        className={`bi ${
                          isInWishlist(item) ? "bi-heart-fill" : "bi-heart"
                        }`}
                      ></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
